import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ShieldCheck, XCircle } from "lucide-react";
import { api } from "../../lib/api";
import { fmtTRY } from "../../lib/format";

export default function MockThreeDSPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const session = params.get("session");

  useEffect(() => {
    if (!session) { navigate("/"); return; }
    api.get(`/payments/mock-session/${session}`).then(({ data }) => setInfo(data)).catch(() => navigate("/"));
  }, [session]);

  const complete = async (action) => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/mock-complete", { session, action });
      navigate(`/odeme/sonuc?order=${data.order_number}`);
    } catch {
      navigate("/odeme/sonuc?order=");
    }
  };

  return (
    <div className="min-h-screen bg-[#0F1115] flex items-center justify-center px-4">
      <Helmet><title>3D Secure Doğrulama | BIGELDİ</title></Helmet>
      <div className="w-full max-w-sm bg-white rounded-3xl overflow-hidden shadow-2xl" data-testid="mock-3ds-page">
        <div className="bg-[#0B4DA2] text-white p-5">
          <div className="flex items-center justify-between">
            <p className="font-display font-bold">Garanti BBVA</p>
            <span className="text-[10px] font-bold bg-amber-400 text-neutral-900 px-2 py-1 rounded-full" data-testid="3ds-test-badge">TEST ORTAMI</span>
          </div>
          <p className="text-xs text-blue-200 mt-1">3D Secure Doğrulama (Simülasyon)</p>
        </div>
        <div className="p-6 space-y-5">
          {info && (
            <div className="bg-[#F4F2EB] rounded-2xl p-4 text-sm space-y-1.5">
              <div className="flex justify-between"><span className="text-neutral-500">İşyeri</span><span className="font-semibold">BIGELDİ</span></div>
              <div className="flex justify-between"><span className="text-neutral-500">Sipariş</span><span className="font-mono-ed text-xs">{info.order_number}</span></div>
              <div className="flex justify-between"><span className="text-neutral-500">Taksit</span><span className="font-semibold">{info.installment === 1 ? "Tek çekim" : `${info.installment} taksit`}</span></div>
              <div className="flex justify-between text-base pt-1 border-t border-[#E6E4DD]"><span className="text-neutral-500">Tutar</span><span className="font-mono-ed font-bold">{fmtTRY(info.total)}</span></div>
            </div>
          )}
          <div className="text-center">
            <ShieldCheck size={40} className="mx-auto text-[#0B4DA2] mb-2" />
            <p className="text-xs text-neutral-500 leading-relaxed">
              Gerçek akışta burada bankanızın SMS doğrulama ekranı olur. Kart bilgileri BIGELDİ sunucularından hiç geçmez.
            </p>
          </div>
          <div className="space-y-2">
            <button onClick={() => complete("success")} disabled={busy}
              className="w-full h-12 rounded-xl bg-emerald-600 text-white font-semibold hover:bg-emerald-500 disabled:opacity-50" data-testid="3ds-success-btn">
              Doğrula ve Öde
            </button>
            <div className="grid grid-cols-2 gap-2">
              <button onClick={() => complete("fail")} disabled={busy}
                className="h-11 rounded-xl border border-rose-300 text-rose-600 text-sm font-semibold hover:bg-rose-50" data-testid="3ds-fail-btn">
                Kart Reddi Simüle Et
              </button>
              <button onClick={() => complete("cancel")} disabled={busy}
                className="h-11 rounded-xl border border-neutral-300 text-neutral-500 text-sm font-semibold hover:bg-neutral-50 flex items-center justify-center gap-1.5" data-testid="3ds-cancel-btn">
                <XCircle size={14} /> İptal Et
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
